module.exports = __webpack_public_path__ + "img/Morri.808cf66f.png";